import React from "react";
import {ServiceSurveysWithIdSchema} from "../../types";
import {DesignSurveysSelectorProps} from "./types";
import Checkbox from "@ui-components/Checkbox";
import {FormattedMessage, useIntl} from "react-intl";
import moment from "moment";

export const SurveysSelector = ({
  services,
  surveys,
  creators,
  value,
  onChange,
  onlyOnePerService=false,
  onlyOne=false,
}: DesignSurveysSelectorProps) => {

  // hooks
  const intl = useIntl();

  // utilities
  const data = services.reduce(
    (acc, curr) => {
      const serviceSurveys = surveys.filter((s) => s.service_id === curr.id);
      if (serviceSurveys.length === 0)
        return acc;
      return {...acc, [curr.name]: serviceSurveys}
    },
    {} as {[key: string]: ServiceSurveysWithIdSchema[]}
  );
  const isSurveySelected = (survey: ServiceSurveysWithIdSchema) =>
    value.some((s) => s.id === survey.id);
  const isSurveyEnabled = (survey: ServiceSurveysWithIdSchema) =>
    isSurveySelected(survey)
    || (onlyOnePerService && value.every((s) => s.service_id !== survey.service_id))
    || (onlyOne && value.length === 0);
  const toggleSurvey = (survey: ServiceSurveysWithIdSchema) => {
    if (isSurveySelected(survey))
      onChange(value.filter((s) => s.id !== survey.id));
    else
      onChange([...value, survey]);
  }

  return (
    <div className="flex flex-col gap-4">
      {Object.keys(data).map((serviceName, idx) => (
        <div key={idx} className="flex flex-col gap-2">
          <h4 className="font-semibold text-xs">
            {serviceName}
          </h4>
          <div>
            {data[serviceName].map((survey: ServiceSurveysWithIdSchema, idx: number) => {
              const identifier = `${serviceName}-${idx}`;
              const creator = creators?.[survey.id_creator!];
              const isDisabled = !isSurveyEnabled(survey);
              return (
                <div key={idx} className={`${idx % 2 === 0 ? "bg-gray-100" : "bg-gray-50"} ${isDisabled ? "cursor-not-allowed" : "cursor-auto"} flex flex-row items-start gap-4 p-3`}>
                  <div>
                    <Checkbox
                      id={identifier}
                      name={identifier}
                      checked={isSurveySelected(survey)}
                      onChange={() => {
                        if (isDisabled) return;
                        toggleSurvey(survey);
                      }}
                      disabled={isDisabled}
                      classNames={isDisabled ? "cursor-not-allowed" : "cursor-pointer"}
                    />
                  </div>
                  <div className={isDisabled ? "opacity-40" : ""}>
                    <p className="font-semibold">
                      {survey.name || intl.formatMessage({id: "unnamed_configuration"})}
                    </p>
                    <p className="text-xs">
                      <FormattedMessage id="created_on" />{" "}
                      {moment(survey.created_at).local().format("DD/MM/YYYY")}{" "}
                      <FormattedMessage id="at" />{" "}
                      {moment(survey.created_at).local().format("HH:mm")}{" "}
                      <FormattedMessage id="by" />{" "}
                      {creator?.firstname} {creator?.lastname}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  )
}